import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { PageheaderComponent } from '../../../../../Components/pageheader/pageheader.component';
import { IPageHeader } from '../../../../../Components/pageheader/pageHeader.model';
import { ArticlesViewComponent } from '../../../../../Components/articles-view/articles-view.component';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';
import { BaseComponent } from '../../../../base.component';
import { IPopup } from '../../../../../Components/popup/popup.model';
import {
  DOMAIN_TYPE,
  NATIONAL_PAGES,
  SCHEMA_TYPE,
} from '../../../../../constants';
import { AutoUnsubscribe } from '../../../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../../../Services/schoolApi.service';
import { IList } from '../../../../../Models/list.model';
import { IResponse } from '../../../../../Models/response.model';
import { ISchoolArticle } from '../../../../../Models/schoolArticle.model';

@AutoUnsubscribe()
@Component({
  selector: 'app-primary',
  standalone: true,
  imports: [PageheaderComponent, ArticlesViewComponent, TranslateModule],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './primary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrimaryComponent extends BaseComponent {
  public pageOptions: IPageHeader = {
    mainPage: { title: 'academics', path: '/academics' },
    children: [
      {
        title: 'stages',
        path: '/academics#STAGES_SECTION',
      },
      {
        title: 'primary',
        path: null,
      },
    ],
  };

  public smallPrimArticlesArray: IPopup[] = [];
  public bigPrimArticlesArray: IPopup[] = [];

  public smallPrimStart: number = 1;
  public smallPrimLimit: number = 5;
  public smallPrimTotalcount: number;

  public bigPrimStart: number = 1;
  public bigPrimLimit: number = 5;
  public bigPrimTotalcount: number;

  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef
  ) {
    super(schoolApiService);
    this.domainType = DOMAIN_TYPE.NATIONAL;
    this.schemaType = SCHEMA_TYPE.ARTICLE;
  }

  ngOnInit(): void {
    this.onSmallPrimPaginateEvent(0);
    this.onBigPrimPaginateEvent(0);
  }

  onSmallPrimPaginateEvent($event: number) {
    this.smallPrimStart = $event;
    this.articleType = NATIONAL_PAGES.ACADEMICS.STAGES.PRIMARY.PRIMARY_SMALL;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.smallPrimStart,
        limit: this.smallPrimLimit,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.smallPrimTotalcount = data.payload?.count || 0;
          this.smallPrimArticlesArray = this.mapArticles(
            data.payload?.list || []
          );
          this.cdr.detectChanges();
        }
      });
  }

  onBigPrimPaginateEvent($event: number) {
    this.bigPrimStart = $event;
    this.articleType = NATIONAL_PAGES.ACADEMICS.STAGES.PRIMARY.PRIMARY_BIG;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.bigPrimStart,
        limit: this.bigPrimLimit,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.bigPrimTotalcount = data.payload?.count || 0;
          this.bigPrimArticlesArray = this.mapArticles(
            data.payload?.list || []
          );
          this.cdr.detectChanges();
        }
      });
  }
}
